// extracted by mini-css-extract-plugin
export default {"rectangle-block":"AssociatedArtist_rectangle-block__QwSdL"};